import { Color, Mesh } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { ReferenceSystem } from '../../reference-system/reference-system.model';
import { Simulation } from '../../simulation.model';
import { ReferenceSystemBuilder } from '../object-builders/reference-system-builder.model';
import GraphicProperties from './graphic-properties.model';

export class ReferenceSystemGraphicProperties extends GraphicProperties {
  color: Color;

  constructor({ color = new Color('#ff5c21') } = {}) {
    super();
    this.color = color;
  }

  updateColor(color: Color): void {}

  async build(
    riser: Catenary3D,
    simulation: Simulation,
    connection: ReferenceSystem,
  ): Promise<Mesh> {
    this.object = await this.getBuilder().build(riser, simulation, connection);
    return this.object;
  }

  getBuilder(): ReferenceSystemBuilder {
    return new ReferenceSystemBuilder();
  }

  delete(): void {
    if (!this.object) {
      return;
    }
    this.object.removeFromParent();
  }
}
